export default {
    //ProductList
    your_created_projects: "Os seus cursos criados",
    new_project: "Novo Curso",
    projects_name: "NOME DO CURSO",
    update_at: 'Actualizado em ',
    coming_soon: 'Próximamente',
    search_your_project: 'Pesquise o seu produto...',
    project_name: 'NNome do produto',
    loading_products: 'Carregamento de produtos...',

    //ProductEditComponent
    modify_project: 'Modificar o seu produto',
    general: 'Geral',
    branding: 'Marca',
    product_page: 'Página do produto',
    sale: 'Venda',
    seo_text: 'SEO',
    projects: 'Projectos',

    //CategoriesSlideOverComponent
    categories: 'Categorias',
    text_category: 'Classifique os seus produtos por categoria para facilitar aos seus alunos a compra dos seus cursos.',
    select_category: 'Seleccione a categoria...',
    ebook: 'E-book',
    online_project: 'Curso online',
    blended_learning: 'Curso de aprendizagem mista',
    online_program: 'Programa Online',
    webinar_consulting: 'Webinar / Consultoria online',
    remove_category: 'Remover categoria',
    href_help: 'Gostaria de saber mais sobre as categorias',

    //ProductEdit
    //CustomCategoriesComponent
    //GeneralComponent
    category: 'Categoria',
    duration: 'Duração',
    featured_product: 'Produto em Destaque',
    delete_project: 'Eliminar Curso',
    warning_delete: 'Atenção!',
    message_delete_project: 'Ao apagar o curso, perderá permanentemente todos os seus dados.',
    question_delete_project: 'Tem a certeza de que quer apagar este curso?',
    delete: 'Eliminar',
    confirmation_delete_project: '(*) Esta caixa é obrigatória para apagar o curso.',
    //PageComponent
    principal_page: 'Página inicial',
    objects_presentation: 'Apresentação e objectos',
    learning_objectives: 'Não se esqueça de descrever brevemente os objectivos de aprendizagem.',
    teaching_staff: 'Metodologia e pessoal docente',
    public: 'Público',
    content: 'Conteúdo',
    sidebar: 'Barra Lateral',
    //ProductBrandingComponent
    banner: 'Banner',
    upload_banner: 'Sube tu banner',
    banner_format: 'PNG, JPG, GIF para 3MB',
    promotional_video: 'Vídeo Promocional',
    video_url: 'URL do vídeo',
    video_info: 'Se tiver um vídeo promocional, coloque aqui a url do vídeo no Youtube ou no Vimeo.',
    //SellComponent
    price_management: 'Gestão de Preciosa',
    sell_price: 'Preço de venda',
    tax: 'Em euros (-3% de imposto)',
    price_offer: 'Preço da Oferta',
    text_configuration: 'Configuração de texto',
    free_text_button: 'Título do botão de compra livre',
    text_if_free: 'Este título aparecerá se o seu produto for gratuito',
    on_sale: 'Para venda',
    sale_info: 'Se activado, o seu produto estará à venda',

    //SeoComponent
    seo_configuration: 'Configuração SEO',
    seo_title: 'Título SEO',
    slug: 'Slug',
    seo_description: 'Descrição SEO',

    //ProductListComponent
    featured: 'Destaque',
    classroom: 'Sala de aula',
    slug_text: 'slug',
    product: 'produto',
    products: 'produtos',
    preview: 'Pré-visualizaçãoVin',

    //AttachProjectSlideOverComponent
    attach_project: 'Projecto Associado',
    loading_projects: 'Carregamento de projectos associados...',
    project_selected: 'Projecto seleccionado',
    quest_attach_project: 'Quer anexar este projecto?',
    back: 'Volver',
    add_project: 'Anexar Projecto',
    close_panel: 'Fechar painel',

    //ProjectAttachedListComponent
    attached_projects: 'Projectos Associados',
    loading_products_attached: 'Carregamento de produtos associados...',
    unattach_project: 'Projecto Desassociar',
    info_unattach_project: 'Ao dissociar o projecto do produto, os estudantes que comprarem o produto não poderão ter acesso ao projecto.',
    quest_unattach_project: 'Tem a certeza de querer dissociar o projecto ',

    // ProductList · paginación y estados
    search_label: 'Pesquisar cursos',
    actions: 'Ações',
    edit_product: 'Editar curso',
    load_error: 'Não foi possível carregar os cursos.',
    retry: 'Tentar novamente',
    no_results_title: 'Nenhum curso corresponde a «{search}»',
    no_results_text: 'Experimente outro nome ou verifique a ortografia.',
    clear_search: 'Limpar pesquisa',
    empty_title: 'Ainda não criou nenhum curso',
    empty_text: 'Crie o seu primeiro curso para começar a vendê-lo na sua academia.',
    product_published: 'O curso foi publicado',
    product_unpublished: 'O curso foi despublicado',
    unexpected_error: 'Ocorreu um erro inesperado',

    // TipTapEditorComponent · menú de bloques (página de producto)
    blocks_menu: 'Blocos',
    blocks_menu_label: 'Inserir um bloco predefinido',
    block_badge: 'Aviso em destaque',
    block_key_facts: 'Dados-chave',
    block_separator: 'Separador',
    block_price_enroll: 'Preço e inscrição',

    // BlockControls · controles de cada bloque
    block_move_up: 'Subir «{block}»',
    block_move_down: 'Descer «{block}»',
    block_remove: 'Remover «{block}»',
    block_remove_confirm_title: 'Remover este bloco?',
    block_remove_confirm_text: 'O bloco desaparecerá do texto. Pode recuperá-lo com Anular (Ctrl+Z) enquanto não guardar.',
    block_remove_confirm_action: 'Remover',

    // PriceEnrollNodeView · bloque «Precio e inscripción»
    price_enroll_price: 'Preço ou texto',
    price_enroll_price_placeholder: 'Ex.: 1.200 € / Bonificado / Grátis',
    price_enroll_button_text: 'Texto do botão',
    price_enroll_button_url: 'Ligação do botão',
    price_enroll_note: 'Nota (opcional)',
    price_enroll_button_color: 'Cor do botão',
    price_enroll_url_invalid: 'Introduza uma ligação que comece por https://, http:// ou mailto:',
    price_enroll_no_button: 'Sem uma ligação válida, o botão não será mostrado na página pública.',
    price_enroll_default_button: 'Inscreva-se',

    // InfoPricesNodeView · bloque «Tarifas informativas»
    block_info_prices: 'Preços informativos',
    info_prices_title: 'Título (opcional)',
    info_prices_title_placeholder: 'Ex.: Módulo de Inspeção do Trabalho',
    info_prices_row: 'Linha {n}',
    info_prices_row_label: 'Etiqueta',
    info_prices_row_label_placeholder: 'Ex.: Associados',
    info_prices_row_amount: 'Montante',
    info_prices_row_amount_placeholder: 'Ex.: 360 € / Bonificado',
    info_prices_add_row: 'Adicionar linha',
    info_prices_remove_row: 'Remover linha {n}',
    info_prices_accent_color: 'Cor da primeira linha',
    info_prices_default_row_1: 'Tarifa geral',
    info_prices_default_row_2: 'Tarifa reduzida',

    // LinkButtonNodeView · bloque «Botón de enlace»
    block_link_button: 'Botão de ligação',
    link_button_default_text: 'Mais informações',
    link_button_text: 'Texto do botão',
    link_button_url: 'Ligação',
    link_button_url_invalid: 'Introduz uma ligação que comece por https://, http:// ou mailto:',
    link_button_no_link: 'Sem uma ligação válida o botão não é mostrado. Adiciona uma ligação que comece por https://, http:// ou mailto:',
    link_button_color: 'Cor do botão',
    link_button_variant: 'Estilo',
    link_button_variant_solid: 'Preenchido',
    link_button_variant_outline: 'Contorno',

    // TipTapEditorComponent · barra de herramientas (FE-054)
    editor_toolbar: 'Formatação do texto',
    editor_bold: 'Negrito',
    editor_italic: 'Itálico',
    editor_underline: 'Sublinhado',
    editor_strike: 'Rasurado',
    editor_heading_2: 'Título 2',
    editor_heading_3: 'Título 3',
    editor_heading_4: 'Título 4',
    editor_bullet_list: 'Lista com marcadores',
    editor_ordered_list: 'Lista numerada',
    editor_align_left: 'Alinhar à esquerda',
    editor_align_center: 'Centrar',
    editor_align_right: 'Alinhar à direita',
    editor_blockquote: 'Citação',
    editor_code_block: 'Bloco de código',
    editor_link: 'Ligação',
    editor_remove_link: 'Remover ligação',
    editor_insert_image: 'Inserir imagem',
    editor_horizontal_rule: 'Linha horizontal',
    editor_text_color: 'Cor do texto',
    editor_remove_color: 'Remover cor',
    editor_undo: 'Anular',
    editor_redo: 'Refazer',
    editor_edit_html: 'Editar HTML',
    editor_insert_badge: 'Inserir aviso destacado',
    editor_insert_icon_list: 'Inserir lista com ícones',
    editor_insert_raw_html: 'Inserir HTML personalizado (sem restrições)',
    editor_badge_panel: 'Aviso destacado:',
    editor_badge_border: 'Borda',
    editor_badge_text: 'Texto',
    editor_badge_background: 'Fundo',
    editor_icon_list_panel: 'Lista com ícones:',
    editor_icon_list_color: 'Cor do ícone',
    editor_link_url: 'URL da ligação:',
    editor_image_url: 'URL da imagem:',
    editor_apply: 'Aplicar',
    editor_cancel: 'Cancelar',
    editor_html_source: 'Código HTML',
}
